import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React from "react";

export function OLCrest(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 28 32">
      <path
        d="M27.472 15.273c0 8.477-9.604 13.336-13.736 16.466v-8.717L14.902 22l.032-.027c4.123-3.633 6.843-6.03 6.843-8.968 0-2.402-1.946-4.288-4.422-4.288a4.878 4.878 0 00-3.619 1.63V0l13.736 6.11v9.163z"
        fill="#fff"
        opacity=".8"
      />
      <path
        d="M0 6.11L13.736 0v10.346a4.878 4.878 0 00-3.619-1.63c-2.476 0-4.422 1.887-4.422 4.289 0 2.944 2.73 5.343 6.864 8.979l.01.009 1.167 1.029v8.717C9.827 29.056 0 23.749 0 15.273V6.11z"
        fill="#fff"
      />
    </SvgIcon>
  );
}
